// Match the data permissions enforced by the analytics API.
export const analyticsAccess = (perms = {}) => {
  const totalIn = !!(perms.viewDeposit || perms.managerViewDeposit);
  const totalOut = !!(perms.viewWithdraw || perms.managerViewWithdraw);
  const tasks = !!perms.viewTaskPerm;
  return {
    totalIn,
    totalOut,
    totalDiff: totalIn && totalOut,
    balance: !!(
      perms.viewUserBalanceEquityWalletTradingHistory || perms.managerViewUserBalanceEquityWalletTradingHistory
    ),
    tasksOpenCount: tasks,
    tasksClosedCount: tasks,
    tasksAllCount: tasks,
    tasksOverdueCount: tasks,
  };
};
